import { useLocalStorageState } from './useLocalStorageState';

const STORAGE_KEY = 'matchiGridLadiesOnly';
const DEFAULT_VALUE = false;

export const useLadiesOnly = () => {
	const [ladiesOnly, setLadiesOnly] = useLocalStorageState(STORAGE_KEY, DEFAULT_VALUE);
	return { ladiesOnly, setLadiesOnly };
};
